<h2 class="sectionTitle">Circular Request - Clone Request</h2>
<app-circular-request #circularsRequest (rebateRequestLoadedFlag)="onCircularsRequestLoadedFlag($event)">
</app-circular-request>